import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from 'src/services/services.service';

interface Hospital {
  id: number;
  name: string;
  doctor: string;
  city: string;
  services: number;
  image: string;

  address?: string;
  phone?: string;
  website?: string;
  notes?: string;
  stallNo?: string;
}

@Component({
  selector: 'app-view-services',
  templateUrl: './view-services.component.html',
  styleUrls: ['./view-services.component.scss']
})
export class ViewServicesComponent {

  hospitals: Hospital[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: ServicesService,
  ) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.StallOwner(id);
  }

  StallOwner(id: any) {
    this.service.get_stall_owner(id).subscribe(
      (res: any) => {

        console.log(res);

        // If API returns an array
        const data = Array.isArray(res.data) ? res.data : [res.data];

        this.hospitals = data.map((item: any) => ({
          id: Number(item.so_id),
          name: item.company_name,
          doctor: item.owner_name,
          city: this.getCity(item.address),
          services: 0, // Replace when API provides count
          image: item.image_path
            ? item.image_path
            : 'assets/images/hospital.png',

          address: item.address,
          phone: item.owner_number,
          website: item.website,
          notes: item.notes,
          stallNo: item.stall_num
        }));

      },
      error => {
        console.error(error);
      }
    );
  }

  getCity(address: string): string {

    if (!address) {
      return '';
    }

    const parts = address.split(',');

    return parts.length > 1
      ? parts[parts.length - 2].trim()
      : address;

  }

  openHospital(hospital: Hospital) {
    this.router.navigate(['/ViewServicesDetail', hospital.id]);
  }

}